
import { AllocatedLab, PassOrFail } from "@gtpl/shared-models/common-models";

export class RejectedIndentReq {


    indentFromdate?:Date;
    indentToDate?:Date;
    indentNumber?: number;
    grnFromDate?:Date;
    grnToDate?:Date
    grnNumber?:number;
    lotNumber?:number;
    status?:PassOrFail;
    count?:number;
    farmer?:string
    allotedLab?:AllocatedLab
    testAt?:string

    constructor(
        indentFromdate?:Date,
        indentToDate?:Date,
        indentNumber?: number,
        grnFromDate?:Date,
        grnToDate?:Date,
        grnNumber?:number,
        lotNumber?:number,
        status?:PassOrFail,
        count?:number,
        farmer?:string,
        allotedLab?:AllocatedLab,
        testAt?:string


    ){
        this.indentFromdate= indentFromdate
        this.indentToDate = indentToDate
        this.indentNumber = indentNumber
        this.grnFromDate = grnFromDate
        this.grnToDate = grnToDate
        this.grnNumber = grnNumber  
        this.lotNumber = lotNumber
        this.status = status
        this.count = count
        this.farmer = farmer
        this.allotedLab = allotedLab
        this.testAt = testAt
       
        
    }
}
